import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column kn-width-full kn-height-full" }
const _hoisted_2 = { class: "p-d-flex p-flex-row" }
const _hoisted_3 = { class: "p-d-flex p-flex-column kn-overflow kn-flex" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "kn-relative kn-flex p-m-2 registry-custom-card" }
const _hoisted_6 = { class: "kn-height-full kn-width-full kn-absolute" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_RegistryFiltersCard = _resolveComponent("RegistryFiltersCard")
  const _component_RegistryPivotDatatable = _resolveComponent("RegistryPivotDatatable")
  const _component_RegistryDatatable = _resolveComponent("RegistryDatatable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary kn-width-full" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.registry.title')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "kn-button p-button-text",
            onClick: _ctx.saveRegistry
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar",
            "data-test": "progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        (_ctx.filters.length > 0)
          ? (_openBlock(), _createBlock(_component_RegistryFiltersCard, {
              key: 0,
              id: _ctx.id,
              propFilters: _ctx.filters,
              entity: _ctx.entity,
              onFilter: _ctx.filterRegistry,
              class: ""
            }, null, 8, ["id", "propFilters", "entity", "onFilter"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_ctx.isPivot)
            ? (_openBlock(), _createBlock(_component_RegistryPivotDatatable, {
                key: 0,
                columns: _ctx.columns,
                id: _ctx.id,
                rows: _ctx.rows,
                entity: _ctx.entity,
                propConfiguration: _ctx.configuration,
                propPagination: _ctx.pagination,
                onRowChanged: _ctx.onRowChanged,
                onRowDeleted: _ctx.onRowDeleted,
                onPageChanged: _ctx.updatePagination,
                onResetRows: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updatedRows = [])),
                onWarningChanged: _ctx.setWarningState
              }, null, 8, ["columns", "id", "rows", "entity", "propConfiguration", "propPagination", "onRowChanged", "onRowDeleted", "onPageChanged", "onWarningChanged"]))
            : (_openBlock(), _createBlock(_component_RegistryDatatable, {
                key: 1,
                propColumns: _ctx.columns,
                id: _ctx.id,
                propRows: _ctx.rows,
                propConfiguration: _ctx.configuration,
                columnMap: _ctx.columnMap,
                pagination: _ctx.pagination,
                entity: _ctx.entity,
                stopWarningsState: _ctx.stopWarningsState,
                onRowChanged: _ctx.onRowChanged,
                onRowDeleted: _ctx.onRowDeleted,
                onPageChanged: _ctx.updatePagination,
                onWarningChanged: _ctx.setWarningState
              }, null, 8, ["propColumns", "id", "propRows", "propConfiguration", "columnMap", "pagination", "entity", "stopWarningsState", "onRowChanged", "onRowDeleted", "onPageChanged", "onWarningChanged"]))
        ])
      ])
    ])
  ]))
}